var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPinHijau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 38,
    viewBox: "0 0 25 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9628 0H12.4998H12.0367C5.37012 0 0 4.9181 0 12.0635C0 18.0953 8.14782 32.7569 10.5089 36.8864C10.9255 37.5822 11.6201 38 12.4071 38H12.4533H12.4995C13.2864 38 14.0272 37.5825 14.3976 36.8864C16.8516 32.8033 25 18.1416 25 12.1099C25 4.91843 19.5835 0 12.9633 0H12.9628ZM12.5001 18.1416C9.30564 18.1416 6.667 15.5434 6.667 12.2955C6.66668 9.094 9.30564 6.4958 12.5001 6.4958C15.6945 6.4958 18.3331 9.094 18.3331 12.3419C18.3331 15.5434 15.6942 18.1416 12.5001 18.1416Z",
    fill: "#029642"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinHijau);
export default __webpack_public_path__ + "static/media/pin-hijau.4dd64dd61edd5e9d3c2f73756f181409.svg";
export { ForwardRef as ReactComponent };